module.exports = __webpack_public_path__ + "img/all.0eebafbb.svg";